import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import Flickity from "react-flickity-component";
import CollectionItemHover from "./CollectionItemHover";
import VideoView from "../assets-view/VideoView";
import { setSelectItem, unsetSelectItem } from "../../actions/ClientAction";
import { showPermissionModal } from "../../actions/PermissionAction";
import { resumeDownload } from "../../actions/DownloadAction";
import DocumentView from "../document-view/DocumentView";
import { Popover, Icon } from "antd";
import ContextMenu from "../context-menu/ContextMenu";
import {
  AUDIO_EXT,
  IMAGE_EXT,
  getImageAssettByExtension,
  getNewPermission,
  getDeletePermissionName
} from "../../utils";
import { setKeyCollection, setkeyboardEnabled } from "../../actions/AppAction";
import fileextension from "file-extension";
import { SVGView } from "../assets-view/SVGView";
import "./CollectionHorizontal.css";
import CustomCheckSelector from "../custom-check-selector/CustomCheckSelector";
import {
  updateModalVisibility,
  addItemSelect
} from "../../actions/MultiselectAction";
import { individualSelectItem } from "../../actions/IndividualSelectAction";
import { setSelectEditAsset } from "../../actions/ClientAction";
import RightsSeal, { RightsUnavailable } from "./RightsSeal";

export class CollectionHorizontal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      folderColor: "#2E97CF",
      hoverDetail: null,
      showDownloadDrawer: false,
      itemSelectedState: null,
      canConvertionFolder: false,
      canDownload: true,
      canShare: true,
      canDelete: true,
      canEdit: true,
      canAddFavorite: true,
      canMove: true,
      canPermissions: true,
      canTagsProtocol: true,
      canCommentsAndVersions: false,
      canCreateVersionDart: false,
      canViewVersionsDart: false,
      canBunkeyHost: false,
      canShareLinkBunkeyHost: false
    };
  }

  componentDidMount() {
    const {
      newColor,
      user,
      newMatrix,
      keyCollection,
      // folderselect,
      itemSelected
    } = this.props;
    if (newColor) {
      this.setState({
        folderColor: newColor
      });
    }

    if (keyCollection === "assetsPublicShared") {
      this.setState({
        canDownload: true,
        canShare: false,
        canDelete: false,
        canEdit: false,
        canAddFavorite: false,
        canMove: false,
        canPermissions: false,
        canCommentsAndVersions: false,
        canCreateVersionDart: false,
        canViewVersionsDart: false,
        canBunkeyHost: false,
        canShareLinkBunkeyHost: false,
        canTagsProtocol: false
      });
    } else if (user.clientRole !== "admin" && user.role !== "admin" && itemSelected) {
      this.setState({
        canDownload: getNewPermission(itemSelected._id, newMatrix, "download"),
        canEdit: getNewPermission(itemSelected._id, newMatrix, 'edit'),
        canDelete: getNewPermission(itemSelected._id, newMatrix, 'delete'),
        canShare: getNewPermission(itemSelected._id, newMatrix, 'share'),
        canMove: getNewPermission(itemSelected._id, newMatrix, 'move'),
      });
    }

    this.setState({
      canConvertionFolder:
        user &&
        user.clientRole === "admin" &&
        user.role === "admin" &&
        (user.email === "jorge@bunkey.tv" || user.email === "victor@bunkey.tv")
    });
  }

  componentDidUpdate(prevProps) {
    const { newColor } = this.props;
    if (prevProps.newColor !== newColor) {
      this.setState({
        folderColor: newColor
      });
    }
  }

  handleShowTagProtocolModal = r => {
    this.props.individualSelectItem(
      r,
      "tag_protocol",
      this.props.keyCollection
    );
  };

  handleShowShareModal = r => {
    this.props.individualSelectItem(r, "share", this.props.keyCollection);
  };

  handleMiddleView = r => {
    const { keyCollection, indice, from, handlerSelectFlickity } = this.props;

    if (r.isSelected === true) {
      this.props.unsetSelectItem(keyCollection);
    } else {
      const elementIndex = Number(indice.split("-")[1]);
      handlerSelectFlickity(elementIndex);
      this.props.setSelectItem(keyCollection, r, from, indice);
    }
  };

  handleSetSrc = r => {
    const { originalURL, lowQualityURL } = r;
    const itemUrl =
      originalURL !== lowQualityURL
        ? lowQualityURL
        : getImageAssettByExtension(r.originalURL);
    return itemUrl;
  };

  handleHideDownloadDrawer = () => {
    this.setState({ showDownloadDrawer: false });
    this.props.setkeyboardEnabled(false);
  };

  handleShowRenameModal = r => {
    const { keyCollection } = this.props;

    if (r && r.type === "bunker") {
      this.props.individualSelectItem(r, "rename");
    } else {
      this.props.individualSelectItem(r, "renameFile", keyCollection);
    }
  };

  handleShowMoveModal = r => {
    this.props.individualSelectItem(r, "move", this.props.keyCollection);
  };
  handleShowDownloadModal = r => {
    console.log(r);
    if (r.type === "folder" || r.type === "bunker") {
      this.props.resumeDownload(r._id)
    } else {
      this.props.individualSelectItem(r, "download", this.props.keyCollection);
    }
  };
  handleShowGroup = r => {
    this.props.individualSelectItem(r, "group");
  };

  handleShowDeleteModal = r => {
    this.props.individualSelectItem(r, "delete", this.props.keyCollection);
  };

  handleGetPermissionFileOrFolder = (item_id, newMatrix, permission ) => {
    const {
      user,
      keyCollection
    } = this.props;
    if (keyCollection === "assetsPublicShared") {
      if (permission === "download") {
        return true
      } else {
        return false
      }
    } else {
      if (user.clientRole !== "admin" && user.role !== "admin") {
        return getNewPermission(item_id, newMatrix, permission)
      } else {
        return true;
      }
    }
  }


  render() {
    const {
      data,
      isHover,
      indice,
      keyCollection,
      intl,
      setFlickityRef,
      itemSelected,
      newMatrix,
      selectedFiles = []
    } = this.props;
    const {
      folderColor,
      hoverDetail,
      canConvertionFolder,
      // canDownload,
      // canDelete,
      // canShare,
      // canMove,
      // canEdit,
      canTagsProtocol
    } = this.state;
    let cont = 0;
    return (
      <Flickity
        className={"first-carousel"}
        elementType={"div"}
        options={{
          cellAlign: "left",
          contain: true,
          pageDots: false,
          pauseAutoPlayOnHover: true,
          draggable: true
        }}
        disableImagesLoaded={true}
        fullscreen={true}
        reloadOnUpdate={false}
        static={false}
        flickityRef={c => setFlickityRef(c)}
      >
        {data.map((r, k) => {
          if (r.type === "folder" || r.type === "bunker") {
            cont++;
            if (cont > 8) cont = 1;
          }

          return (
            <div
              key={k}
              className={`carousel-cell ${
                itemSelected && itemSelected._id === r._id
                  ? "selectedAsset"
                  : ""
              } ${
                selectedFiles.some(file => file._id === r._id)
                  ? "rights-selected-card"
                  : ""
              }`}
              onMouseEnter={() =>
                this.props.handleOnMouseEnter(`horizontal-${k}`)
              }
              onMouseLeave={() =>
                this.props.handleOnMouseLeave(`horizontal-${k}`)
              }
            >
              {(r.type === "folder" || r.type === "bunker") && (
                <ContextMenu
                  keyCollection={keyCollection}
                  item={r}
                  menuItem={[
                    {
                      event: () => {
                        this.props.showPermissionModal(r);
                        this.props.setKeyCollection(keyCollection);
                        this.handleShowGroup(r);
                      },
                      icon: "safety-certificate",
                      text: intl.formatMessage({ id: "groups" })
                    },
                    // canDownload
                    this.handleGetPermissionFileOrFolder(r._id, newMatrix, "download")
                      ? {
                          event: () => this.handleShowDownloadModal(r),
                          icon: "cloud-download",
                          text: intl.formatMessage({ id: "download_asset" })
                        }
                      : null,
                    // canEdit 
                    this.handleGetPermissionFileOrFolder(r._id, newMatrix, 'edit')
                      ? {
                        event: () => this.handleShowRenameModal(r),
                        icon: "edit",
                        text:  intl.formatMessage({
                          id: "rename_asset"
                        })
                      } : null,
                    // canMove
                    this.handleGetPermissionFileOrFolder(r._id, newMatrix, 'move') 
                      ? {
                        event: () => this.handleShowMoveModal(r),
                        icon: "logout",
                        text: intl.formatMessage({
                          id: "move_asset"
                        })
                      } : null,
                    canTagsProtocol &&
                    (r.type === "folder" || r.type === "bunker")
                      ? {
                          event: () => this.handleShowTagProtocolModal(r),
                          icon: "tags",
                          text: "Protocolos de tags"
                        }
                      : null,
                    this.handleGetPermissionFileOrFolder(r._id, newMatrix, 'share')
                      ? {
                        event: () => this.handleShowShareModal(r),
                        icon: "share-alt",
                        text: intl.formatMessage({
                          id: "shared_share"
                        })
                      } : null,
                    this.handleGetPermissionFileOrFolder(r._id, newMatrix, getDeletePermissionName(r.type))
                      ? {
                        event: () => this.handleShowDeleteModal(r),
                        icon: "delete",
                        text: intl.formatMessage({
                          id: "delete_asset"
                        })
                      } : null,
                    canConvertionFolder &&
                    (r.type === "folder" || r.type === "bunker")
                      ? {
                          event: () => {
                            this.props.convertionFolder(r._id);
                          },
                          icon: "rocket",
                          text: intl.formatMessage({
                            id: "convetinator_force_conversion"
                          })
                        }
                      : null
                  ]}
                >
                  <div
                    className={`slide-wrapper hand color-${cont}`}
                    style={{
                      backgroundColor: folderColor,
                      paddingRight: "10px"
                    }}
                    onClick={() =>
                      this.props.handleOnClickExplore(r._id, r.name)
                    }
                  >
                    {/* Icono que muestra popover que describe contenidos del bunker */}
                    {keyCollection === "assetsRoot" &&
                      r.longDescription &&
                      r.longDescription !== "" && (
                        <Popover content={r.longDescription}>
                          <Icon
                            type="info-circle"
                            style={{
                              color: "#fff",
                              marginTop: "5px",
                              marginLeft: "23px"
                            }}
                          />
                        </Popover>
                      )}

                    {/* Nombre de las carpetas */}
                    {r.name.length > 30 ? (
                      <Popover content={r.name} placement="bottom">
                        <p>{`${r.name.slice(0, 31)}...`}</p>
                      </Popover>
                    ) : (
                      <p>{r.name}</p>
                    )}
                  </div>
                </ContextMenu>
              )}
              {r.type !== "folder" && r.type !== "bunker" && (
                <ContextMenu
                  keyCollection={keyCollection}
                  item={r}
                  menuItem={[
                    {
                      event: () => {
                        this.props.showPermissionModal(r);
                        this.props.setKeyCollection(keyCollection);
                        this.handleShowGroup(r);
                      },
                      icon: "safety-certificate",
                      text: intl.formatMessage({ id: "groups" })
                    },
                    this.handleGetPermissionFileOrFolder(r._id, newMatrix, "download")
                      ? {
                          event: () => this.handleShowDownloadModal(r),
                          icon: "cloud-download",
                          text: intl.formatMessage({ id: "download_asset" })
                        }
                      : null,
                    this.handleGetPermissionFileOrFolder(r._id, newMatrix, 'edit')
                      ? {
                        event: () => this.handleShowRenameModal(r),
                        icon: "edit",
                        text: intl.formatMessage({
                          id: "rename_asset"
                        })
                      } : null,
                    this.handleGetPermissionFileOrFolder(r._id, newMatrix, 'move') 
                      ? {
                        event: () => this.handleShowMoveModal(r),
                        icon: "logout",
                        text: intl.formatMessage({
                          id: "move_asset"
                        })
                      } : null ,
                    canTagsProtocol &&
                    (r.type === "folder" || r.type === "bunker")
                      ? {
                          event: () => this.handleShowTagProtocolModal(r),
                          icon: "tags",
                          text: "Protocolos de tags"
                        }
                      : null,
                    this.handleGetPermissionFileOrFolder(r._id, newMatrix, 'share')
                      ? {
                        event: () => this.handleShowShareModal(r),
                        icon: "share-alt",
                        text: intl.formatMessage({
                          id: "shared_share"
                        })
                      } : null,
                    this.handleGetPermissionFileOrFolder(r._id, newMatrix, getDeletePermissionName(r.type))
                      ? {
                        event: () => this.handleShowDeleteModal(r),
                        icon: "delete",
                        text: intl.formatMessage({
                          id: "delete_asset"
                        })
                      } : null
                  ]}
                >
                  <div
                    className="slide-wrapper transparent rights-thumb"
                    onClick={() => this.handleMiddleView(r)}
                    onMouseEnter={() =>
                      this.props.handleOnMouseEnter(`horizontal-${k}`)
                    }
                    onMouseLeave={() =>
                      this.props.handleOnMouseLeave(`horizontal-${k}`)
                    }
                  >
                    {r.unavailable ? (
                      <RightsUnavailable />
                    ) : null}
                    {!r.unavailable && r.type === "image" &&
                      fileextension(r.originalURL) === "svg" && (
                        <SVGView src={r.originalURL} assetId={r._id} />
                      )}
                    {!r.unavailable && r.type === "image" &&
                      fileextension(r.originalURL) !== "svg" &&
                      IMAGE_EXT.includes(fileextension(r.originalURL)) && (
                        <img
                          className="img-asset"
                          style={{ padding: "10px" }}
                          alt={r.name}
                          onClick={() =>
                            this.props.handleOnMouseEnter(`horizontal-${k}`)
                          }
                          src={this.handleSetSrc(r)}
                          onError={({ currentTarget }) => {
                            currentTarget.onerror = null; // prevents looping
                            currentTarget.src = "/images/extensions/image.png";
                            currentTarget.className = "img-asset errorAsset";
                          }}
                        />
                      )}
                    {!r.unavailable && r.type === "image" &&
                      fileextension(r.originalURL) !== "svg" &&
                      !IMAGE_EXT.includes(fileextension(r.originalURL)) && (
                        <DocumentView
                          from={`horizontal`}
                          keyCollection={keyCollection}
                          indice={indice}
                          item={r}
                          className="img-asset"
                        />
                      )}
                    {!r.unavailable && r.type === "document" &&
                      !AUDIO_EXT.includes(fileextension(r.originalURL)) && (
                        <DocumentView
                          from={`horizontal`}
                          keyCollection={keyCollection}
                          indice={indice}
                          item={r}
                          className="img-asset"
                        />
                      )}
                    {!r.unavailable && r.type === "video" && (
                      <VideoView
                        url={r.lowQualityURL}
                        loop={true}
                        paddingTop={10}
                        isHoverPlay={true}
                        from={`horizontal`}
                        r={r}
                        indice={indice}
                        keyCollection={keyCollection}
                        disableDefaultControls={true}
                        muted={true}
                      />
                    )}
                    {!r.unavailable && r.type === "font" && (
                      <DocumentView
                        from={`horizontal`}
                        keyCollection={keyCollection}
                        indice={indice}
                        item={r}
                        className="img-asset"
                      />
                    )}
                    {!r.unavailable && r.type === "audio" && (
                      <DocumentView
                        from={`horizontal`}
                        keyCollection={keyCollection}
                        indice={indice}
                        item={r}
                        className="img-asset"
                      />
                    )}
                    {!r.unavailable && r.type === "document" &&
                      AUDIO_EXT.includes(fileextension(r.originalURL)) && (
                        <DocumentView
                          from={`horizontal`}
                          keyCollection={keyCollection}
                          indice={indice}
                          item={r}
                          className="img-asset"
                        />
                      )}
                    {!r.unavailable && r.type === "other" && (
                      <DocumentView
                        from={`horizontal`}
                        keyCollection={keyCollection}
                        indice={indice}
                        item={r}
                        className="img-asset"
                      />
                    )}
                    <RightsSeal asset={r} />
                  </div>
                </ContextMenu>
              )}
              {r.type !== "folder" && r.type !== "bunker" && (
                <div
                  onMouseEnter={() =>
                    this.props.handleOnMouseEnter(`horizontal-${k}`)
                  }
                  onMouseLeave={() =>
                    this.props.handleOnMouseLeave(`horizontal-${k}`)
                  }
                >
                    {!r.unavailable && isHover && `horizontal-${k}` === indice && (
                    <CollectionItemHover
                      itemHover={r}
                      from={`horizontal`}
                      indice={indice}
                      hoverDetail={hoverDetail}
                      keyCollection={keyCollection}
                    />
                  )}
                </div>
              )}
              {keyCollection !== "assetsPublicShared" && (
                <CustomCheckSelector
                  isHover={isHover}
                  k={k}
                  indice={indice}
                  itemHover={r}
                  hoverDetail={hoverDetail}
                  keyCollection={keyCollection}
                  from={`horizontal`}
                  handleOnMouseEnter={() =>
                    this.props.handleOnMouseEnter(`horizontal-${k}`)
                  }
                  handleOnMouseLeave={() =>
                    this.props.handleOnMouseLeave(`horizontal-${k}`)
                  }
                  folderOrBunker={r.type === "folder" || r.type === "bunker"}
                />
              )}
            </div>
          );
        })}
      </Flickity>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { keyCollection } = ownProps;
  let object;
  switch (keyCollection) {
    case "assetsRoot":
      object = {
        isFetching: state.assetsRoot.isFetching,
        data: state.assetsRoot.data,
        itemSelected: state.assetsRoot.data.find(r => r.isSelected),
        folderselect: state.assetsRoot.folderselect,
        error: state.assetsRoot.error,
        activeView: state.assetsRoot.activeView,
        itemEditSelected: state.assetsRoot.data.find(r => r.isEditSelected),
        keyboardEnable: state.app.keyboardEnable
      };
      break;
    case "assetsLastUploads":
      object = {
        isFetching: state.assetsLastUploads.isFetching,
        data: state.assetsLastUploads.data,
        itemSelected: state.assetsLastUploads.data.find(r => r.isSelected),
        folderselect: state.assetsLastUploads.folderselect,
        error: state.assetsLastUploads.error,
        activeView: state.assetsLastUploads.activeView,
        keyboardEnable: state.app.keyboardEnable
      };
      break;
    case "assetsShared":
      object = {
        isFetching: state.assetsShared.isFetching,
        data: state.assetsShared.data,
        itemSelected: state.assetsShared.data.find(r => r.isSelected),
        folderselect: state.assetsShared.folderselect,
        error: state.assetsShared.error,
        activeView: state.assetsShared.activeView,
        keyboardEnable: state.app.keyboardEnable
      };
      break;
    case "assetsFavorites":
      object = {
        isFetching: state.assetsFavorites.isFetching,
        data: state.assetsFavorites.data,
        itemSelected: state.assetsFavorites.data.find(r => r.isSelected),
        folderselect: state.assetsFavorites.folderselect,
        error: state.assetsFavorites.error,
        activeView: state.assetsFavorites.activeView,
        keyboardEnable: state.app.keyboardEnable
      };
      break;
    case "assetsExplore":
      object = {
        isFetching: state.assetsExplore.isFetching,
        data: state.assetsExplore.data,
        itemSelected: state.assetsExplore.data.find(r => r.isSelected),
        folderselect: state.assetsExplore.folderselect,
        error: state.assetsExplore.error,
        activeView: state.assetsExplore.activeView,
        keyboardEnable: state.app.keyboardEnable
      };
      break;
    case "searcher":
      object = {
        isFetching: state.searcher.isFetching,
        data: state.searcher.data,
        itemSelected: state.searcher.data.find(r => r.isSelected),
        folderselect: state.searcher.folderselect,
        error: state.searcher.error,
        searchText: state.searcher.searchText,
        activeView: state.searcher.activeView,
        keyboardEnable: state.app.keyboardEnable
      };
      break;
    case "assetsPublicShared":
      object = {
        isFetching: state.assetsPublicShared.isFetching,
        data: state.assetsPublicShared.data,
        itemSelected: state.assetsPublicShared.data.find(r => r.isSelected),
        folderselect: state.assetsPublicShared.folderselect,
        error: state.assetsPublicShared.error,
        searchText: state.assetsPublicShared.searchText,
        activeView: state.assetsPublicShared.activeView,
        keyboardEnable: state.app.keyboardEnable
      };
      break;
    default:
      object = {};
      break;
  }

  return {
    ...object,
    newColor:
      state.authUser.user && state.authUser.user.color
        ? state.authUser.user.color
        : "#2E97CF",
    isDownloading: state.downloads.isDownloading,
    user: state.authUser.user,
    selectedFiles: state.selectedFiles.data,
    matrix: state.group.matrix,
    newMatrix: state.group.newMatrix
  };
};

const mapDispatchToProps = {
  setSelectItem,
  unsetSelectItem,
  showPermissionModal,
  setKeyCollection,
  resumeDownload,
  setkeyboardEnabled,
  updateModalVisibility,
  addItemSelect,
  individualSelectItem,
  setSelectEditAsset
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(CollectionHorizontal))
);
